<template>
  <div class="bg-[#23242A] text-white app-header p-3 custom" id="content_screen">
    <div class="p-3 flex content-main gap-5">
      <div class="custom-full custom-left">
        <div class="bg-[#2B2C32] rounded-lg max-w-full py-[16px]">
            <div class="flex justify-between px-[16px] h-[40px]">
                <div class="flex flex-row items-center gap-2">
                    <svg @click="back" class="cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="white"/>
                    </svg>
                    <div class="flex flex-row items-center gap-2">
                      <h1 v-if="!editAuditName" class="text-xl font-bold tracking-wide text-white">{{ audit?.name }}</h1>
                      <input v-else @keydown="updateAuditName" v-model="auditName" placeholder="Enter Audit Name" class="block border-0 rounded bg-[#1C1D21] w-full text-sm focus:ring-0" type="text">
                      <svg v-if="audit?.status!=='completed' && !editAuditName" @click="editAuditName = true" class="cursor-pointer" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8M12.2501 1.75015C12.5153 1.48493 12.875 1.33594 13.2501 1.33594C13.6251 1.33594 13.9848 1.48493 14.2501 1.75015C14.5153 2.01537 14.6643 2.37508 14.6643 2.75015C14.6643 3.12522 14.5153 3.48493 14.2501 3.75015L8.2414 9.75949C8.0831 9.91765 7.88753 10.0334 7.67273 10.0962L5.7574 10.6562C5.70003 10.6729 5.63922 10.6739 5.58134 10.6591C5.52345 10.6442 5.47061 10.6141 5.42836 10.5719C5.38611 10.5296 5.35599 10.4768 5.34116 10.4189C5.32633 10.361 5.32733 10.3002 5.34406 10.2428L5.90406 8.32748C5.96708 8.11285 6.08309 7.91752 6.2414 7.75948L12.2501 1.75015Z" stroke-width="2" stroke-linecap="round" stroke="#9CA3AF"/>
                      </svg>
                    </div>
                </div>
                <div class="flex flex-row items-center gap-2">
                    <button @click="exportReport" class="cursor-pointer text-sm font-medium tracking-widest rounded text-white border border-theme-green py-2 px-3 disabled:cursor-default disabled:border-0 disabled:cursor-default disabled:bg-[#414141] hover:bg-theme-darkgreen hover:text-white">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M19 9.5H15V3.5H9V9.5H5L12 16.5L19 9.5ZM11 11.5V5.5H13V11.5H14.17L12 13.67L9.83 11.5H11ZM19 20.5V18.5H5V20.5H19Z" fill="white"/>
                        </svg>
                    </button>
                    <button @click="openUpload" class="flex items-center border border-theme-green hover:bg-theme-darkgreen text-white py-1 h-10 px-3 rounded-md cursor-pointer">
                      <span>Re-Import</span>
                    </button>
                    <button @click="back" v-if="audit?.status!=='completed'" class="cursor-pointer text-sm font-medium tracking-widest rounded text-white border border-theme-green py-2 px-3 hover:bg-theme-darkgreen hover:text-white disabled:border-0 disabled:cursor-default disabled:bg-[#414141]">
                        EXIT
                    </button>
                    <button @click="completeAudit" :disabled="!can_complete_audit || !allActualQtyAdded()" v-if="audit?.status!=='completed'" class="cursor-pointer text-sm font-medium tracking-widest rounded text-white bg-theme-green py-2 px-3 disabled:cursor-default disabled:bg-[#414141] hover:bg-theme-darkgreen hover:text-white">
                        COMPLETE
                    </button>
                    <button @click="removeAudit" class="cursor-pointer text-sm font-medium tracking-widest rounded text-white border border-theme-gray py-2 px-3 hover:bg-theme-red hover:border-theme-red hover:text-white">
                      Delete Audit
                    </button>
                </div>
            </div>            
        </div>

        <div class="bg-[#2B2C32] rounded-lg max-w-full p-4 flex justify-start items-start gap-8 mt-4">
          <div class="size- inline-flex flex-col justify-start items-start gap-1">
            <div class="justify-start text-gray-400 text-xs font-normal font-['Roboto']">Started On</div>
            <div class="justify-start text-gray-50 text-xs font-medium font-['Roboto']">{{ startedOn }}</div>
          </div>
          <div class="size- inline-flex flex-col justify-start items-start gap-1">
            <div class="justify-start text-gray-400 text-xs font-normal font-['Roboto']">Completed On</div>
            <div class="justify-start text-gray-50 text-xs font-medium font-['Roboto']">{{ completedOn ? completedOn : '&nbsp;&nbsp;&nbsp;-' }}</div>
          </div>
          <div class="size- inline-flex flex-col justify-start items-start gap-1">
            <div class="justify-start text-gray-400 text-xs font-normal font-['Roboto']">Audit Type</div>
            <div class="justify-start text-gray-50 text-xs font-medium font-['Roboto']">Regular</div>
          </div>
          <div class="size- inline-flex flex-col justify-start items-start gap-1">
            <div class="justify-start text-gray-400 text-xs font-normal font-['Roboto']">Employee</div>
            <div class="justify-start text-gray-50 text-xs font-medium font-['Roboto']">{{ audit.creator }}</div>
          </div>
        </div>

        <div class="bg-[#2B2C32] mt-4">
            <div class="flex gap-4 items-center p-4 w-full">
                <div class="w-3/5">
                    <input v-model="search" class="bg-[#464851] border rounded w-full h-10 focus:ring-0 focus:border-theme-green" placeholder="Search" type="text">
                </div>
                <div class="w-[150px]" v-if="audit.status!=='completed'">
                    <button @click="refreshStock" class="border border-theme-green rounded w-full h-10">Refresh Stock</button>
                </div>
                <div class="flex items-center w-[200px]">
                    <input type="checkbox" v-model="showDiscrepancies" class="w-6 h-6 mr-3 text-theme-green border-2 rounded-sm bg-transparent border-white focus:border-0 focus:ring-0 focus:outline-0">
                    <label class="text-sm tracking-wider font-normal">Discrepancies Only</label>
                </div>
                <button :disabled="audit?.status==='completed'" @click="showAddProductModal" class="w-[160px] h-10 px-4 py-2 bg-theme-green rounded-md flex justify-center items-center gap-2 overflow-hidden disabled:cursor-default disabled:bg-[#414141] disabled:opacity-100 hover:opacity-80">
                  <span class="justify-center text-white text-sm font-medium font-['Roboto'] uppercase leading-4 tracking-widest">Add Product</span>
                </button>
            </div>
            <new-table-lite
                :is-static-mode="true"
                :is-slot-mode="true"
                :is-loading="table.loading"
                :class="'block w-full min-h-[480px] admin-template'"
                :columns="table.columns"
                :rows="table.rows"
                :page="table.page"
                :total="table.totalRecords"
                :sortable="table.sortable"
                :page-size="table.pagesize"
                @do-search="changePage"
                :pageOptions='table.pageOptions'
                :messages="{
                    pagingInfo: 'Total: {2}',
                    pageSizeChangeLabel: 'Items per Page',
                    gotoPageLabel: 'Go to page',
                    noDataAvailable: 'No records found!',
                }"
            >
                <template v-slot:productSku="data">
                    <span>{{ data.value?.product?.sku }}</span>
                </template>
                <template v-slot:liveStock="data">
                    <span>{{ data.value.batchId?live[`${data.value.productId}-${data.value.batchId}`]:live[data.value.productId] }}</span>
                </template>
                <template v-slot:adjustBy="data">
                  <span :class="data.value.adjustBy>0?'text-theme-green':(data.value.adjustBy<0?'text-theme-red':'')">{{ data.value.adjustBy>0?'+':null }}{{data.value.adjustBy}}</span>
                </template>
                <template v-slot:actualInventory="data">
                  <div class="flex flex-col gap-2 relative">
                    <span class="text-grey">{{data.value.updatedAt?formatTime(data.value.updatedAt):'-'}}</span>
                    <div class="flex flex-row items-end gap-2">
                      <input :disabled="audit.status==='completed'" tabIndex="1" type="text" min="0" oninput="validity.valid||(value='');" class="w-16 disabled:border-theme-black bg-transparent border rounded" :value="data.value.actualInventory" :id="data.value.id" @keydown="focusNext" :onkeypress="preventNonNumbersAndDecimal" @change="updateQty(data.value, $event)" @keyup="updateQty(data.value, $event)" />
                      <svg v-show="(audit.status!=='completed' && data.value.actualInventory != null && data.value.actualInventory !== '') || (audit.status==='completed' && notes[data.value.id])" @click="toggleNote(data.value.id)" :class="notes[data.value.id] ? 'fill-theme-green' : 'fill-white'" class="w-5 h-5 shrink-0 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 19V5H12V12H19V13C19.7 13 20.37 13.13 21 13.35V9L15 3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.89 21 5 21H13.35C13.13 20.37 13 19.7 13 19H5M14 4.5L19.5 10H14V4.5M23 18V20H20V23H18V20H15V18H18V15H20V18H23Z" /></svg>
                    </div>
                    <div v-show="openNotes[data.value.id]" class="absolute top-20 -right-[50px] w-80 p-4 z-20 bg-zinc-800 rounded-lg shadow-[0px_8px_24px_0px_rgba(0,0,0,0.40)] outline outline-1 outline-offset-[-1px] outline-gray-700 inline-flex flex-col justify-start items-start gap-3">
                      <div class="absolute right-0 -top-4 right-[155px] h-0 w-0 border-x-8 border-x-transparent border-b-[16px] border-b-gray-black"></div>
                      <div v-if="audit.status==='completed'">
                        <div class="self-stretch justify-start text-white text-sm font-bold font-['Roboto']">{{ notes[data.value.id] }}</div>
                      </div>
                      <div class="self-stretch inline-flex flex-col justify-start items-start gap-3" v-else>
                        <div class="self-stretch justify-start text-white text-sm font-bold font-['Roboto']">Edit note</div>
                        <div class="self-stretch flex flex-col justify-start items-start gap-1.5 overflow-hidden">
                          <div class="self-stretch justify-start text-gray-400 text-xs font-medium font-['Roboto']">Note</div>
                          <textarea
                            v-model="notes[data.value.id]"
                            :disabled="audit.status==='completed'"
                            rows="2"
                            placeholder="Add a note"
                            class="self-stretch h-20 p-3 bg-gray-800 rounded-sm outline outline-1 outline-offset-[-1px] outline-emerald-600 inline-flex justify-start items-start overflow-hidden"
                          />
                        </div>
                        <div class="self-stretch inline-flex justify-end items-start gap-2 overflow-hidden">
                          <button @click="toggleNote(data.value.id)" class="h-9 px-4 py-2 rounded-md outline outline-1 outline-offset-[-1px] outline-gray-500 flex justify-center items-center overflow-hidden hover:opacity-80">
                            <span class="justify-start text-white text-sm font-medium font-['Roboto']">Cancel</span>
                          </button>
                          <button @click="updateNote(data.value)" class="h-9 px-4 py-2 bg-emerald-600 rounded-md flex justify-center items-center overflow-hidden hover:opacity-80">
                            <span class="justify-start text-white text-sm font-bold font-['Roboto']">Save</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:final="data">
                  <span>{{finalCount(data.value)}}</span>
                </template>
                <template v-slot:newInventory="data">
                  <span>{{data.value?.newInventory? data.value.newInventory:0}}</span>
                </template>
            </new-table-lite>
        </div>

      </div>
    </div>
    <upload-pop v-if="uploadPop" @close="closeUpload" @uploadedPayload="uploadedPayload" />
    <delete-confirm-modal v-if="deleteConfirmModal" @close="closeDeleteConfirm" @confirm="confirmRemoveAudit" />
    <AddProduct v-if="addProductModal" :payload="audit" @resetSearchClose="resetSearchClose()" @close="addProductModal = false" />
  </div>
</template>

<script>
import Env from '@/env';
import {defineComponent, ref} from "vue"
import ProductAuditApi from '@/controllers/ProductAuditApis'
import NewTableLite from '@/components/table/tableLite.vue'
import moment from 'moment-timezone'
import {mapActions} from 'vuex'
import Helpers from '@/helpers';
import { useSnackbar } from "vue3-snackbar";
import debounce from 'lodash/debounce'
import writeXlsxFile from 'write-excel-file';
import UploadPop from './UploadPop.vue'
import DeleteConfirmModal from './DeleteConfirmModal.vue'
import AddProduct from './AddProduct.vue'

export default defineComponent({
  name: "AuditView",
  components: {
    NewTableLite,
    UploadPop,
    DeleteConfirmModal,
    AddProduct,
  },
  setup() {
    const snackbar = useSnackbar();
    const loading = ref(false)
    const audit = ref([])
    const live = ref({})
    const editAuditName = ref(false)
    const auditName = ref('')
    const startedOn = ref('')
    const completedOn = ref('')
    const search = ref('')
    const showDiscrepancies = ref(false)
    const uploadPop = ref(false)
    const deleteConfirmModal = ref(false)
    const addProductModal = ref(false)
    const openNotes = ref({})
    const notes = ref({})
    const columns = [
      {label: 'Id', field: 'id', sortable:false, isKey:true, columnClasses:'hidden', headerClasses:'hidden' },
      {label: 'Product', field:'productName', sortable: true},
      {label: 'Sku', field:'productSku', sortable:false, headerClasses:'width'},
      {label: 'Lot #', field: 'batchName', sortable: false},
      {label: 'Category', field:'categoryName', sortable:true},
      {label: 'In Stock', field:'expectedInventory', sortable: false},
      {label: 'Live Stock', field:'liveStock', sortable: false},
      {label: 'Adjust By', field: 'adjustBy', sortable: true},
      {label: 'Inv. Count', field:'actualInventory', sortable: false, width: '220px'},
      {label: 'Final Count', field:'final', sortable: false},
    ]
    const completedColumn = [
      {label: 'Product', field:'productName', sortable: true},
      {label: 'Sku', field:'productSku', sortable:false, headerClasses:'width'},
      {label: 'Lot #', field: 'batchName', sortable: false},
      {label: 'Category', field:'categoryName', sortable:true},
      {label: 'Stock At Start', field:'expectedInventory', sortable: false},
      {label: 'Inv. Count', field:'actualInventory', sortable: false, width: '220px'},
      {label: 'Adjust By', field: 'adjustBy', sortable: true},
      {label: 'Final Count', field:'newInventory', sortable: false},
    ]
    const table = ref({
        loading: false,
        columns: [],
        rows: [],
        totalRecords: 0,
        page: 1,
        pagesize: Env.defaultPageSize,
        sortable: {
            order: "productName",
            sort: "asc",
        },
        count: 0,
        clearChecked: false,
    })
    const mainTimer = ref(null)
    const mainPrevId = ref(null)
    const timer = ref(null)

    return {
      snackbar,
      loading,
      audit,
      live,
      editAuditName,
      auditName,
      startedOn,
      completedOn,
      search,
      showDiscrepancies,
      uploadPop,
      deleteConfirmModal,
      addProductModal,
      openNotes,
      notes,
      table,
      mainTimer,
      mainPrevId,
      timer,
      columns,
      completedColumn
    }
  },
  async mounted() {
    this.loading = true
    this.table.loading = true
    await this.fetchData()
    await this.liveInventory()
    this.table.loading = false
    this.loading = false
    this.searchProduct()
  },
  watch: {
    search(){
      this.searchProduct()
    },
    showDiscrepancies(){
      this.searchProduct()
    }
  },
  computed: {
    can_complete_audit() {
        return Helpers.getMyPermission('can_approve_inventory_audits')
    },
    can_view_live_stock() {
        return Helpers.getMyPermission('can_view_live_stock_in_audit')
    }
  },
  methods: {
    removeAudit(){
      this.deleteConfirmModal = true
    },
    closeDeleteConfirm(){
      this.deleteConfirmModal = false
    },
    async confirmRemoveAudit(){
      this.deleteConfirmModal = false
      this.va_spinner(true)
      this.va_audit(true)
      let res = await ProductAuditApi.removeAudit(this.$route.params.id)
      this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? 'Audit deleted successfully.' : Helpers.catchErrorMessage(res.response?.data),
        duration: 3000,
      })
      if(res.status == 200){
        this.$router.push({name: 'ProductAudits'})
      }
      this.va_spinner(false)
    },
    /**
     * 
     *  Do not allow to add +,-,e ,. 
     */
    preventNonNumbersAndDecimal(e) {
      var ASCIICode = (e.which) ? e.which : e.keyCode
      if (ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101 || e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        return false;
      }
      return true;
    },
    openUpload(){
      this.uploadPop = true
    },
    closeUpload(){
        this.uploadPop = false
    },
    async uploadedPayload(){
        this.closeUpload()
        this.table.loading = true
        await this.fetchData()
        this.table.loading = false
    },
    finalCount(data){
      let liveCount = data.batchId?this.live[`${data.productId}-${data.batchId}`]:this.live[`${data.productId}`]
      if(data.adjustBy){
        return parseInt(liveCount)+(data.adjustBy)
      }else{
        return liveCount
      }
    },
    focusNext(e){
      if(e.code=='Enter'){
        let ind = this.table.rows.findIndex(each => each.id==e.target.id)
        if(ind>=0 && this.table.rows[ind+1]?.id){
          let ele = document.getElementById(this.table.rows[ind+1].id)
          if(ele){
            ele.focus()
          }
        }
      }else if(this.timer){
        clearTimeout(this.timer)
      }
    },
    formatDate(date){
      if(!date) return

      return moment(date).format('YYYY-MM-DD')
    },
    formatTime(time){
       if(!time) return
      return moment(time).format('HH:mm')
    },
    async fetchData(){
      let res =  await ProductAuditApi.auditDetail(this.$route.params.id);
      if(res.data?.payload){
        this.audit = res.data.payload
        this.auditName = this.audit?.name
        this.startedOn = this.audit?.startedOn? moment(this.audit.startedOn).format('YYYY-MM-DD, hh:mm A'):null
        this.completedOn = this.audit?.completedOn? moment(this.audit.completedOn).format('YYYY-MM-DD, hh:mm A'):null
        const details = res.data.payload.locationInventoryAuditdetails || []
        const noteMap = {}
        details.forEach(row => {
          noteMap[row.id] = row.note ?? this.notes[row.id] ?? ''
        })
        this.notes = noteMap
        this.table.rows = details
        this.table.totalRecords = details.length
        this.va_audit(res.data.payload.status==='completed'?true:false)
      }
    },
    async updateAuditName(){
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        let res = await ProductAuditApi.updateAuditName(this.$route.params.id, {name: this.auditName})
        this.audit = res.data.payload
        this.auditName = this.audit?.name
        this.editAuditName = false;
        this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? 'Audit name updated successfully.' : Helpers.catchErrorMessage(res.response.data),
        })
      }, 2000)
    },
    async liveInventory(){
        let res = await ProductAuditApi.liveInventory(this.$route.params.id)
        if(res.data?.payload){
            this.live = res.data.payload
        }
    },
    async refreshStock(){
        this.loading = true
        this.table.loading = true
        // await this.fetchData()
        await this.liveInventory()
        this.searchProduct()
        this.table.loading = false
        this.loading = false
    },
    showAddProductModal(){
      this.addProductModal = true
    },
    async resetSearchClose(){
      this.addProductModal = false
      this.table.loading = true
      await this.fetchData()
      await this.liveInventory()
      this.searchProduct()
      this.table.loading = false
    },
    changePage(offset, limit){
        this.table.page = (offset/limit)+1
    },
    searchProduct(){
      if(this.audit){
        this.table.loading = true
        this.table.columns = (this.completedOn) ? this.completedColumn : this.columns
        if(this.search && this.showDiscrepancies){
          this.table.rows = this.audit.locationInventoryAuditdetails.filter(each => each.productName.toLowerCase().includes(this.search.toLowerCase()) && each.adjustBy!=0)
          this.table.totalRecords = this.table.rows.length
          this.table.page = 1
        }else if(this.search){
          this.table.rows = this.audit.locationInventoryAuditdetails.filter(each => each.productName.toLowerCase().includes(this.search.toLowerCase()))
          this.table.totalRecords = this.table.rows.length
          this.table.page = 1
        } else if(this.showDiscrepancies){
          this.table.rows = this.audit.locationInventoryAuditdetails.filter(each => each.adjustBy!=0)
          this.table.totalRecords = this.table.rows.length
          this.table.page = 1
        } else{
          this.table.rows = this.audit.locationInventoryAuditdetails
          this.table.totalRecords = this.audit.locationInventoryAuditdetails.length
        }
        this.table.loading = false
      }
    },
    allActualQtyAdded(){
        if(this.audit.locationInventoryAuditdetails?.length===0) return false
        return this.audit.locationInventoryAuditdetails?.every(each => each.actualInventory!==null)
    },
    toggleNote(id){
      this.openNotes[id] = !this.openNotes[id]
    },
    updateNote(data){
      if(this.mainPrevId==data.id){
        clearTimeout(this.mainTimer)
      }
      this.mainPrevId = data.id
      const note = this.notes[data.id] ?? ''
      const qtyEl = document.getElementById(data.id)
      const qty = qtyEl ? qtyEl.value : data.actualInventory
      this.openNotes[data.id] = false
      if((data.note || '') === note && String(data.actualInventory ?? '') == String(qty ?? '')){
        return
      }
      const actualInventory = (qty === '' || qty === null || qty === undefined)
        ? data.actualInventory
        : (parseInt(qty, 10) || 0)
      this.persistProductAudit(data, actualInventory, note)
    },
    updateQty(data, e) {
      const currentValue = e.target.value
      if(String(data.actualInventory ?? '') === currentValue){
        return
      }
      if(this.mainPrevId==data.id){
        clearTimeout(this.mainTimer)
      }
      const actualInventory = currentValue === '' ? null : (parseInt(currentValue, 10) || 0)
      data.actualInventory = actualInventory
      this.mainPrevId = data.id
      this.mainTimer = setTimeout(() => {
        this.persistProductAudit(data, actualInventory == null ? 0 : actualInventory, this.notes[data.id] || '')
      }, 1000)
    },
    async persistProductAudit(data, actualInventory, note){
      const rowId = data.id
      let obj = {
          actualInventory: actualInventory,
          expectedInventory: data.expectedInventory,
          realTimeStock: data.batchId?this.live[`${data.productId}-${data.batchId}`]:this.live[data.productId],
          note: note || ""
      }
      let res =  await ProductAuditApi.updateProductAudit(rowId, obj);
      this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? 'Product Audit Saved.' : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      if(res.status != 200){
        return
      }
      const pendingQty = {}
      ;(this.audit?.locationInventoryAuditdetails || []).forEach(row => {
        pendingQty[row.id] = row.actualInventory
      })
      await this.fetchData()
      ;(this.audit?.locationInventoryAuditdetails || []).forEach(row => {
        const pending = pendingQty[row.id]
        const justSaved = String(row.id) === String(rowId) && String(pending ?? '') === String(actualInventory ?? '')
        if(pending === undefined || justSaved){
          return
        }
        if(String(pending ?? '') !== String(row.actualInventory ?? '')){
          row.actualInventory = pending
        }
      })
      this.searchProduct()
    },
    async completeAudit(){
      if(!this.auditName){
        return this.snackbar.add({
          type: 'info',
          text: 'Please enter audit name',
          duration: 3000,
        })
      }
      this.va_spinner(true)
      let res = await ProductAuditApi.completeProductAudit(this.$route.params.id)
      this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? 'Audit Complete' : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
      })
      if(res.status==200){
        this.va_audit(true)
        this.$router.push({name: 'ProductAudits'})
      }
      this.va_spinner(false)
    },
    back(){
      this.$router.push({name: 'ProductAudits'})
    },
    async exportReport(){
      try {
        let schema = [
          {
            column: 'Audit detail Id',
            type: Number,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.id
          },
          {
            column: 'Product',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.productName
          },
          {
            column: 'SKU',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.product?.sku?i.product.sku:''
          },
          {
            column: 'Variant',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => {
              if(i.product?.variantName){
                return i.product.variantName;
              } else {
                return '';
              }
            }
          },
          {
            column: 'Category',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => {
              if(i.categoryName){
                return i.categoryName;
              } else {
                return '';
              }
            }
          },
          {
            column: 'Brand',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.brandName ? i.brandName : '' 
          },
          {
            column: 'Lot #',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.batchName ? i.batchName : '' 
          },
          {
            column: 'In Stock',
            type: Number,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.expectedInventory ? i.expectedInventory : '' 
          }
        ]

        if(this.can_view_live_stock && this.audit?.status!=='completed'){
          schema.push({
            column: 'Live Stock',
            type: Number,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.batchId?this.live[`${i.productId}-${i.batchId}`]:this.live[i.productId]
          })
        }

        schema.push(
          {
            column: 'Inventory Count',
            type: Number,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.actualInventory ? i.actualInventory : '' 
          },
          {
            column: 'Notes',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.note ? i.note : '' 
          }
        )

        let xlBlob = await writeXlsxFile(this.audit.locationInventoryAuditdetails, {
          schema: schema,
        });
        let fileName = `audit-${this.audit.name}.xlsx`;
        let url = URL.createObjectURL(xlBlob);
        let link = document.createElement("a");
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        let self = this
        setTimeout(function(){
          self.snackbar.add({
            type: 'info',
            text: 'File downloaded',
            duration: 3000,
          })
        }, 1000)
      } catch(err) {
        console.log(err)
        return this.snackbar.add({
          type: 'info',
          text: 'Something went wrong. Please try again later.',
          duration: 3000,
        })
      }
    },
    ...mapActions({
        va_spinner: 'spinner/setSpinner',
        va_audit: 'audit/setAudit'
    })
  }
})

</script>
